import axios from "axios"

export const estimateTax = (data) => {
    return axios.post('/opc/tax/estimate', data);
};